enum EBusinessType {
  COMPANY = 'company',
  INDIVIDUAL = 'individual',
  SELF_EMPLOYED = 'self_employed',
  INDIVIDUAL_ENTREPRENEUR = 'individual_entrepreneur',
}

export default EBusinessType;
